import React from 'react';
import { Box, Chip } from '@mui/material';
import {
  PriorityHigh as PriorityIcon,
  PersonSearch as PersonSearchIcon,
  Summarize as SummarizeIcon,
  RateReview as ReviewIcon
} from '@mui/icons-material';

const QUICK_ACTIONS = [
  { label: 'Who needs attention?', icon: <PriorityIcon sx={{ fontSize: 14 }} /> },
  { label: 'Review next client', icon: <PersonSearchIcon sx={{ fontSize: 14 }} /> },
  { label: 'Summarize caseload', icon: <SummarizeIcon sx={{ fontSize: 14 }} /> },
  { label: 'Run a review', icon: <ReviewIcon sx={{ fontSize: 14 }} /> }
];

function TassQuickActions({ onAction, disabled }) {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 0.5,
        overflowX: 'auto',
        py: 0.5,
        '&::-webkit-scrollbar': { height: 4 },
        '&::-webkit-scrollbar-thumb': { backgroundColor: 'grey.300', borderRadius: 2 }
      }}
    >
      {QUICK_ACTIONS.map((action) => (
        <Chip
          key={action.label}
          label={action.label}
          icon={action.icon}
          size="small"
          variant="outlined"
          disabled={disabled}
          onClick={() => onAction && onAction(action.label)}
          sx={{
            fontSize: '0.7rem',
            flexShrink: 0,
            '&:hover': { backgroundColor: 'primary.50', borderColor: 'primary.main' }
          }}
        />
      ))}
    </Box>
  );
}

export default TassQuickActions;
